export var isUndefined = function (comp) { return comp === undefined; };
